import { render, staticRenderFns } from "./AddDoctorMsgBox.vue?vue&type=template&id=34e0a4fc&"
import script from "./AddDoctorMsgBox.vue?vue&type=script&lang=js&"
export * from "./AddDoctorMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./AddDoctorMsgBox.vue?vue&type=style&index=0&id=34e0a4fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports